import { datadogRum } from '@datadog/browser-rum';
/**
 * Send an error to Datadog with an optional label for better reporting.
 * @param originalError any
 * @param label String
 */
export const logError = (originalError: any, label?: string) => {
  const error =
    originalError instanceof Error
      ? originalError
      : new Error(String(originalError || 'Unknown error'));

  const errorWithOptionalLabel = new Error(label ?? error.message);
  // Tyepscript doesn't like adding a standard .cause key to errors
  (errorWithOptionalLabel as any).cause = error;
  datadogRum.addError(errorWithOptionalLabel);
};
